const getPageIdsToDelete = (initialPages, currentPages) => {
  const initialPageIds = initialPages.map((p) => p.id);
  const currentPageIdsSet = new Set(currentPages.map((p) => p.id));

  return new Set(initialPageIds.filter((id) => !currentPageIdsSet.has(id)));
};

export default getPageIdsToDelete;
